import * as React from 'react';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as A from 'fp-ts/Array';
import * as R from 'fp-ts/Record';
import { pipe } from 'fp-ts/lib/function';
import { ScorerEventFragment } from '../Stats/utils';
import { Card } from '../../../components/Card';
import { TextLink } from '../../../components/ClickableText';
import { PlayerNameWithAvatar } from '../components/PlayerNameWithAvatar';
import { CardHeading } from '../../../components/CardHeading';
import { isNil } from '../../../utils/isNil';

interface Props {
  scorers: ScorerEventFragment[];
  editLink?: string;
  isSignedIn: boolean;
}

export const ScorerCard: React.FC<Props> = ({
  scorers,
  editLink,
  isSignedIn,
}) => {
  const groupedScorers = pipe(
    scorers,
    NEA.groupBy((s) => s.player.id),
    R.toArray,
    A.map(
      ([, goals]) =>
        [pipe(NEA.head(goals), (a) => a.player), goals.length] as const,
    ),
  );

  return (
    <Card className="space-y-4 bg-white ">
      <CardHeading>Goalscorers</CardHeading>
      <ul className="space-y-3">
        {groupedScorers.map(([player, goals]) => {
          return (
            <li key={player.id} className="flex items-center">
              <PlayerNameWithAvatar player={player} linkToPlayer={isSignedIn} />
              {goals > 1 ? (
                <span className="text-amber-600 ml-2 font-semibold">
                  {goals}
                </span>
              ) : null}
            </li>
          );
        })}
      </ul>
      {!isNil(editLink) ? (
        <p className="text-sm text-right">
          <TextLink to={editLink}>Edit</TextLink>
        </p>
      ) : null}
    </Card>
  );
};
